import { render, staticRenderFns } from "./ReportsEmbed.vue?vue&type=template&id=4829590d&"
import script from "./ReportsEmbed.vue?vue&type=script&lang=js&"
export * from "./ReportsEmbed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports